module.exports = __webpack_public_path__ + "img/PttAvm.d0223047.png";